import { createSelector } from 'reselect';

import { FEATURE_IS_ACTIVE_DEFAULT } from '../constants';
import { selectRawFilterData } from './general';

function _selectFeatures(state, filterId) {
    return selectRawFilterData(state, filterId).features;
}

const selectFeaturesFilterData = createSelector(
    _selectFeatures,
    (features) => Object.entries(features).reduce((map, [featureId, isActive]) => ({
        ...map,
        [featureId]: {
            isActive,
        },
    }), {}),
);

function _isFeaturesFiltered(featureMap) {
    return Object.values(featureMap)
        .some((isActive) => isActive !== FEATURE_IS_ACTIVE_DEFAULT);
}

const selectFeaturesIsFiltered = createSelector(
    _selectFeatures,
    _isFeaturesFiltered,
);

export {
    selectFeaturesFilterData,
    selectFeaturesIsFiltered,
};
